import React, { useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { c as classnames } from './index-2586sEvh.js';
import { useTranslation, Trans } from 'next-i18next';
import { validationSchema, initialValues, initialValuesNoCheckboxes } from './components/SignUpUpdatesForm/form/index.js';
import './utils/logToSlack.js';
import 'lodash/get';
import { CoreContext } from './context/index.js';
import { h as PRIVACY_POLICY } from './paths-ZKN3m62_.js';
import './product-_pRduMz7.js';
import 'next/router';
import { d as dataLayerSubscription } from './subscription-blf7SMVl.js';
import 'lodash/cloneDeep';
import { setUserInformation, setUserCart } from './utils/salesforce.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-zNO-4REJ.js';
import useShowError from './hooks/useShowError.js';
import 'notistack';
import './helpers-kA_hdoOI.js';
import { get } from 'lodash';
import Button from './components/Button/index.js';
import { I as Input } from './Input-quQLghm0.js';
import { InputGroup } from './components/inputs/Input/index.js';
import { C as Checkbox } from './Checkbox-o9DWtxXo.js';
import Link from './components/Link/index.js';
import { T as TriggerValidation } from './TriggerValidation-EwWymetQ.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';
import { subscribeEmailToNewsletter } from './services/newsletter/index.js';
import { getCartSessionId } from './utils/cart.js';

/* eslint-disable jsx-a11y/label-has-associated-control */
const SignUpUpdatesForm = ({ onSuccessCallback, privacyPolicy, className = '', label = '', hahSubscribeCheckbox = false, brandSubscribeCheckbox = false, accorSubscribeCheckbox = false, position, privacySubtitle, subscribeBtnText, inlineSubscribeHeading, }) => {
    const [loading, setLoading] = useState(false);
    const showError = useShowError();
    const { t } = useTranslation('', { keyPrefix: '' });
    const { useDispatch, data: { locale, siteConfig: { siteName, hotelBrandName, catalogId, region, accorTagging: { accorTaggingEnabled = false } = {}, parentHotelCompany, }, }, thunks: { cart: { getCart }, }, } = useContext(CoreContext);
    const dispatch = useDispatch();
    const formMethods = useForm({
        resolver: validationSchema,
        defaultValues: hahSubscribeCheckbox ? initialValues : initialValuesNoCheckboxes,
        mode: 'onSubmit',
    });
    const { register, control, handleSubmit, formState: { errors }, } = formMethods;
    const checkboxesErrorText = get(errors, `checkboxes.message`, '');
    const isCheckboxError = Boolean(checkboxesErrorText);
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            setUserInformation(catalogId, values.email);
            const cartId = getCartSessionId();
            if (cartId) {
                const cart = await dispatch(getCart({ cart_id: cartId, accorTaggingEnabled }));
                if ('items' in cart.payload)
                    setUserCart(cart.payload);
            }
            const agreeSubscribe = values.checkboxes[0];
            const accorSubscriptionText = values.checkboxes[2] || values.checkboxes[1]
                ? `AllAccor_${values.checkboxes[2] ? 'Brand' : ''}${values.checkboxes[1] ? 'News' : ''}`
                : null;
            const subscribePromise = agreeSubscribe
                ? subscribeEmailToNewsletter(region, locale, catalogId, window.location.origin, window.location.href, values.email, position)
                : Promise.resolve(null);
            const accorPromise = accorSubscriptionText
                ? subscribeEmailToNewsletter(region, locale, catalogId, window.location.origin, window.location.href, values.email, position, accorSubscriptionText)
                : Promise.resolve(null);
            if (agreeSubscribe || accorSubscriptionText) {
                await Promise.all([subscribePromise, accorPromise]);
            }
            setLoading(false);
            onSuccessCallback();
            dataLayerSubscription(position);
        }
        catch (error) {
            showError(t('$common.$validation.serverError'));
        }
        return setLoading(false);
    };
    // data attributes
    let eventAttributes = {};
    if (position === 'lightbox') {
        eventAttributes = {
            'data-event-name': 'popin_click',
            'data-event-popin-name': 'newsletter_subscription',
            'data-event-cta-name': subscribeBtnText || t('$common.$buttons.subscribeBtn'),
        };
    }
    else {
        eventAttributes = {
            'data-event-name': 'nl_subscribe',
            'data-event-label': subscribeBtnText || t('$common.$buttons.subscribeBtn'),
            'data-event-category': 'on-page',
            'data-event-action': 'click',
        };
    }
    const footerLabel = () => (React.createElement("label", { htmlFor: label, dangerouslySetInnerHTML: { __html: t('$local.subscribeFooter') }, className: "font-sub-heading", "aria-hidden": true }));
    const privacyNotice = () => (React.createElement("div", { className: "disclaimer", id: "disclaimer" },
        React.createElement(Trans, { i18nKey: "$common.disclaimer", t: t, components: { span: React.createElement("span", null) }, values: { siteName } }),
        "\u00A0",
        React.createElement(Link, { href: `/${locale}${PRIVACY_POLICY}`, target: position === 'lightbox' ? '_blank' : null },
            t('$common.$labels.privacyPolicy'),
            ".")));
    return (React.createElement("form", { onSubmit: handleSubmit(onSubmit), id: `signUpUpdatesForm-${position}`, className: classnames(`sign-up-updates-form ${className}`) },
        React.createElement("fieldset", { className: "sign-up-updates-form-top" },
            React.createElement("legend", { className: "sr-only" }, t('$local.subscribeFooter')),
            position === 'footer' && !inlineSubscribeHeading && footerLabel(),
            !hahSubscribeCheckbox && privacySubtitle && privacyNotice(),
            React.createElement("div", { className: "sign-up-updates-form-contents" },
                React.createElement(InputGroup, null,
                    inlineSubscribeHeading && footerLabel(),
                    React.createElement(Input, { name: "email", autocomplete: "email", register: register, errors: errors, placeholder: t('$common.$validation.emailPleaseEnter'), id: label, inputMode: "email", filled: true, maxLength: 100, ariaLabel: t('$common.$validation.emailPleaseEnter') }),
                    React.createElement(Button, { type: "submit", variant: "none", isLoading: loading, ...eventAttributes }, subscribeBtnText || t('$common.$buttons.subscribeBtn'))),
                hahSubscribeCheckbox && (React.createElement(React.Fragment, null,
                    React.createElement(TriggerValidation, { formMethods: formMethods }),
                    React.createElement(Checkbox, { name: "checkboxes[0]", control: control, errors: errors, ...register('checkboxes.0'), label: React.createElement(React.Fragment, null,
                            t('$common.$agreements.hahSubscribeCheckbox_1'),
                            React.createElement(Link, { target: "_blank", href: privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.url, title: privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.title }, privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.title),
                            t('$common.$agreements.hahSubscribeCheckbox_2', {
                                siteName,
                            })) }),
                    accorSubscribeCheckbox && (React.createElement(Checkbox, { name: "checkboxes[1]", control: control, errors: errors, ...register('checkboxes.1'), label: React.createElement(Trans, { i18nKey: "$accorCommon.allSubscribeCheckbox", t: t, components: {
                                a: (
                                // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                                React.createElement("a", { className: "base-link", href: t('$accorCommon.allSubscribeCheckboxHref'), target: "_blank", rel: "noreferrer" })),
                            }, values: { siteName } }) })),
                    brandSubscribeCheckbox && parentHotelCompany === 'Accor' && (React.createElement(Checkbox, { name: "checkboxes[2]", control: control, errors: errors, ...register('checkboxes.2'), label: React.createElement(Trans, { i18nKey: "$accorCommon.$agreements.brandSubscribeCheckbox", t: t, components: {
                                a: (
                                // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                                React.createElement("a", { className: "base-link", href: t('$accorCommon.$agreements.brandSubscribeCheckboxHref'), target: "_blank", rel: "noreferrer" })),
                            }, values: { brandName: hotelBrandName } }) })),
                    isCheckboxError && (React.createElement("div", { className: "input-container" },
                        React.createElement("div", { className: "error", id: "checkboxesError", role: "alert" }, t(checkboxesErrorText)))))))),
        !hahSubscribeCheckbox && !privacySubtitle && privacyNotice()));
};
var SignUpUpdatesForm$1 = withProviders(SignUpUpdatesForm, { translation: true });

export { SignUpUpdatesForm$1 as S };
//# sourceMappingURL=SignUpUpdatesForm-tDg_YMSO.js.map
